import React from "react";

import LockedState from "components/Templates/Premium/LockedState";
import { LOCKED_HEART_AGE } from "constants/constants.scripts";

const LockedHeartAge = () => <LockedState metricType={LOCKED_HEART_AGE} />;

export default LockedHeartAge;
